/* eslint-disable no-restricted-syntax */
import { forwardRef } from 'react';
import { DocumentNode, useLazyQuery } from '@apollo/client';
import { AsyncCellSelect } from '@aleph/shared-components';
import { ICellEditorParams, ICellEditor } from 'ag-grid-community';

interface IAudienceCellEditorParams extends ICellEditorParams {
	graphqlQuery: DocumentNode;
	valueFieldName: string;
	isMulti?: boolean;
	additionalVariables?: Record<string, unknown>;
}

function findDataItems(obj: unknown): unknown[] | undefined {
	if (!obj || typeof obj !== 'object' || obj === null) return undefined;

	const objWithItems = obj as { items?: unknown };
	if (Array.isArray(objWithItems.items)) return objWithItems.items;

	for (const key of Object.keys(obj)) {
		const found = findDataItems((obj as Record<string, unknown>)[key]);
		if (found) return found;
	}

	return undefined;
}

const AsyncCellSelectEditor = forwardRef<ICellEditor, IAudienceCellEditorParams>((
	{
		valueFieldName,
		graphqlQuery,
		additionalVariables,
		...params
	},
	ref,
) => {
	const [loadSelectOptions] = useLazyQuery(graphqlQuery);

	async function loadOptions(searchQuery: string) {
		const { data } = await loadSelectOptions({
			variables: {
				query: searchQuery !== ''
					? `${valueFieldName} LIKE '%${searchQuery}%'`
					: undefined,
				...additionalVariables,
			},
		});

		return findDataItems(data) ?? [];
	}

	return (
		<AsyncCellSelect
			ref={ref}
			{...params}
			loadOptions={loadOptions}
			isMulti={params.isMulti ?? true}
			selectedValue={params?.value}
			stopEditing={params.stopEditing}
		/>
	);
});

export default AsyncCellSelectEditor;
